<template>
  <div class="g">
    <Top>
      <div class="g_ctn">
        <div class="g_opt">
          <div class="get" @click="handleRefrsh">
            <div class="circular">
              <span class="iconfont icon-yunduanshuaxin" />
            </div>
            <span class="text">读取分组</span>
          </div>
          <div class="get" @click="handleSet">
            <div class="circular">
              <span class="iconfont icon-shezhi" />
            </div>
            <span class="text">设置分组</span>
          </div>
        </div>
      </div>

      <!-- 水泵类型的设备阀门 -->
      <div class="group">
        <div class="item card" v-for="(item, index) in pumpGroups" :key="index">
          <div class="row1">
            <div class="r_t">
              <span class="cir">
                <span class="iconfont icon-shuibeng"></span>
              </span>
              <span class="name">{{ item.groupName }}</span>
            </div>
            <div class="r_b" v-if="item.valveList.length">
              <van-field class="inp" type="number" v-for="(valve, valIndex) in item.valveList" :key="valIndex" :value="valve" @click="handleChangeValve(1, index, valIndex)" />
            </div>
          </div>
          <div class="row2"></div>
        </div>
      </div>

      <!-- 分组阀门 -->
      <div class="group valveGroup">
        <div class="item card" v-for="(item, index) in valveGroups" :key="index">
          <div class="row1">
            <div class="r_t">
              <div class="r_t_l">
                <span class="cir">
                  <span class="iconfont icon-shenghuoshuibengfang"></span>
                </span>
                <span class="name">
                  <van-field type="text" v-model="item.groupName" />
                </span>
              </div>

              <div class="r_t_r">
                <span class="tx">时长</span>
                <span>
                  <van-field class="inp" type="number" v-model="item.min" />
                </span>
                <span class="tx">分钟</span>
              </div>
            </div>
            <div>
              <div class="txt">增减阀门</div>
              <div class="r_b">
                <div class="r_b_l">
                  <van-field class="inp" type="number" v-for="(valve, valIndex) in item.valve_group" :key="valIndex" :value="valve" @click="handleChangeValve(2, index, valIndex)" />
                </div>
                <div class="r_b_r" v-show="false">
                  <div class="btn">
                    <span class="reduce cir" @click="handleReduce(index)">
                      -
                    </span>
                    <span class="value">{{
                      item.valve_group ? item.valve_group.length : 0
                    }}</span>
                    <span class="add cir" @click="handleAdd(index)">+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-popup v-model="visible" position="bottom" :style="{ width: '100%', height: '6.8rem' }">
        <van-picker title="选择阀门" show-toolbar :columns="options" @confirm="onConfirm" @cancel="onCancel" />
      </van-popup>
    </Top>
  </div>
</template>

<script>
import Top from "./../../lunGuan/top.vue";
export default {
  components: {
    Top,
  },

  data () {
    return {
      pumpGroups: [
        {
          groupName: "水泵",
          valveList: ["", "", "", "", "", "", ""],
        },
      ],
      valveGroups: [
        {
          groupName: "第一组",
          valveList: [],
        },
        {
          groupName: "第二组",
          valveList: [],
        },
        {
          groupName: "第三组",
          valveList: [],
        },
        {
          groupName: "第四组",
          valveList: [],
        },
        {
          groupName: "第五组",
          valveList: [],
        },
        {
          groupName: "第六组",
          valveList: [],
        },
        {
          groupName: "第七组",
          valveList: [],
        },
        {
          groupName: "第八组",
          valveList: [],
        },
        {
          groupName: "第九组",
          valveList: [],
        },
        {
          groupName: "第十组",
          valveList: [],
        },
        {
          groupName: "第十一组",
          valveList: [],
        },
        {
          groupName: "第十二组",
          valveList: [],
        },
      ],
      timer: [],
      options: [],
      visible: false,
      optionsType: null, // 1 网关阀门（水泵）   2 RTU阀门（分组）
      deviceIndex: null, // 网关阀门的下标
      valveIndex: null, // 分组阀门的下标
      no: "",
    };
  },
  mounted () {
    const no = localStorage.getItem("no");
    const type = sessionStorage.getItem("deviceType")

    this.no = no;
    const arr = [];

    let num = type == 13 ? 128 : 32


    for (let i = 0; i < num; i++) {
      arr.push(i);
    }
    this.options = [...arr];
    this.getGroup();
  },
  methods: {
    async getGroup () {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      await this.$api
        .lgV2_getGroup(this.no)
        .then((res) => {
          if (res.errcode !== 0) return this.$toast(res.errmsg);

          if (res.data) {
            const { pumpGroups, valveGroups } = res.data;
            const pumpGroupsList = [...this.pumpGroups];
            pumpGroupsList[0].valveList = pumpGroups;
            this.pumpGroups = [...pumpGroupsList];
            console.log("pumpGroups:", this.pumpGroups);
            valveGroups.map((item, i) => {
              if (item.timer) {
                item.min = item.timer / 60;
              }

              if (!item.groupName) {
                item.groupName = `第${i + 1}组`;
              }
            });

            this.valveGroups = [...valveGroups];
          }
        })
        .finally(() => {
          this.$toast.clear();
        });
    },

    // 读取分组
    handleRefrsh () {
      this.getGroup();
    },

    // 切换阀门编号 需要注意是设备的阀门还是分组的阀门
    onConfirm (data) {
      if (this.optionsType === 1) {
        this.pumpGroups[0].valveList[this.valveIndex] = data;
      } else {
        this.valveGroups[this.deviceIndex].valve_group[this.valveIndex] = data;
      }
      this.onCancel();
    },

    onCancel () {
      this.visible = false;
      this.optionsType = null;
      this.deviceIndex = null;
      this.valveIndex = null;
    },

    // 修改阀门 1-32
    handleChangeValve (type, deviceIndex, valveIndex) {
      this.optionsType = type;
      this.deviceIndex = deviceIndex;
      this.valveIndex = valveIndex;
      this.visible = true;
    },

    // 减阀门
    handleReduce (index) {
      if (this.valveGroups[index].valve_group.length) {
        this.valveGroups[index].valve_group.pop();
      } else {
        this.$toast.fail("没有阀门");
      }
    },
    // 加阀门
    handleAdd (index) {
      if (!this.valveGroups[index] || !this.valveGroups[index].valve_group) {
        const tar = { ...this.valveGroups[index] }

        this.$set(this.valveGroups, index, { ...this.valveGroups[index], valve_group: [] })
      }

      console.log(" this.valveGroups[index]:", this.valveGroups[index]);

      if (this.valveGroups[index].valve_group.length < 12) {
        this.valveGroups[index].valve_group.push(0);
      } else {
        this.$toast.fail("最多执行12个阀门");
      }
    },

    // 设置分组
    async handleSet () {
      const valveGroups = JSON.parse(JSON.stringify(this.valveGroups));
      valveGroups.map((o, i) => {
        if (o.min) {
          o.timer = o.min * 60;
        } else {
          o.timer = 0;
        }

        o.valveList = o.valve_group;
        delete o.valve_group;
        delete o.min;
        return o;
      });

      const param = {
        gatewayNo: this.no,
        pumpGroups: {
          groupName: "水泵",
          valveList: this.pumpGroups[0].valveList,
        },
        valveGroups,
      };

      console.log("param:", param);

      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      await this.$api.lgV2_setGroup(param).then((res) => {
        if (res.errcode !== 0) return this.$toast(res.errmsg);

        this.$toast.success("设置成功");
      });

      this.$toast.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
.g {
  background: rgba(241, 247, 255, 1) !important;
}

.g_ctn {
  margin-bottom: 10px;
}

.g_opt {
  display: flex;
  align-items: center;
  height: 55px;
  padding: 18px 28px;
  background: #ffffff;
}

.get {
  display: flex;
  flex: 1;
  align-items: center;
  // justify-content: center;

  &:first-child {
    border-right: 0.5px solid rgba(232, 232, 232, 1);
  }

  &:last-child {
    justify-content: flex-end;
  }

  .text {
    font-size: 16px;
    margin-left: 11px;
  }

  .circular {
    width: 39px;
    height: 39px;
    background: linear-gradient(
      90deg,
      rgba(72, 119, 233, 1) 0%,
      rgba(25, 76, 201, 1) 100%
    );

    border-radius: 50%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon-yunduanshuaxin,
  .icon-shezhi {
    font-size: 24px !important;
  }
}

.card {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 10px 7px;
  margin-bottom: 12px;

  .row1 {
    font-size: 14px;

    .r_t {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
    }

    .txt {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
      padding-right: 10px;
    }

    .r_b {
      display: flex;

      .r_b_l {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
      }

      .inp {
        width: 48px;
        height: 35px;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 7px;
        margin-bottom: 6px;
        padding: 10px;

        ::v-deep input {
          text-align: center !important;
        }
      }

      .cir {
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 24px;
        color: #ffffff;
        border-radius: 50%;
      }

      .reduce {
        background: rgba(214, 218, 221, 1);
        box-shadow: 0px 2px 2px rgba(229, 229, 229, 1);
      }

      .add {
        background: rgba(53, 102, 220, 1);
        box-shadow: 0px 2px 2px rgba(49, 171, 254, 0.2);
      }

      .value {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        margin: 0 9px;
      }

      .btn {
        display: flex;
        align-items: center;
      }
    }

    .icon-shuibeng {
      font-size: 25px;
    }

    .cir {
      display: block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      background: rgba(59, 107, 224, 1);
      color: #ffffff;
      text-align: center;
    }

    .name {
      margin-left: 13px;
      font-size: 16px;
    }
  }
}

.valveGroup {
  .r_t {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(232, 232, 232, 1);
    padding-bottom: 9px;
  }

  .r_t_l {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .r_t_r {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    color: rgba(151, 151, 151, 1);

    .inp {
      width: 60px;
      height: 31px;
      background: rgba(248, 248, 248, 1);
      border-radius: 4px;
      ::v-deep input {
        text-align: center !important;
      }
    }

    .tx {
      margin: 0 5px;
    }
  }
}
</style>
